import customFetch from '../resources/customFetch'
import compileCollection from '../resources/compileCollection'
import api from '../api'
export const SEARCH_PARALLEL_START = 'search/SEARCH_PARALLEL_START'
export const SEARCH_PARALLEL_SUCCEEDED = 'search/SEARCH_PARALLEL_SUCCEEDED'
export const SEARCH_PARALLEL_FAILED = 'search/SEARCH_PARALLEL_FAILED'

export const SEARCH_MONO_START = 'search/SEARCH_MONO_START'
export const SEARCH_MONO_SUCCEEDED = 'search/SEARCH_MONO_SUCCEEDED'
export const SEARCH_MONO_FAILED = 'search/SEARCH_MONO_FAILED'

export const GET_PARALLEL_TEXT_START = 'search/GET_PARALLEL_TEXT_START'
export const GET_PARALLEL_TEXT_SUCCEEDED = 'search/GET_PARALLEL_TEXT_SUCCEEDED'
export const GET_PARALLEL_TEXT_FAILED = 'search/GET_PARALLEL_TEXT_FAILED'

export const GET_MONO_TEXT_START = 'search/GET_MONO_TEXT_START'
export const GET_MONO_TEXT_SUCCEEDED = 'search/GET_MONO_TEXT_SUCCEEDED'
export const GET_MONO_TEXT_FAILED = 'search/GET_MONO_TEXT_FAILED'

export const GET_BOOK_LIST_START = 'search/GET_BOOK_LIST_START'
export const GET_BOOK_LIST_SUCCEEDED = 'search/GET_BOOK_LIST_SUCCEEDED'
export const GET_BOOK_LIST_FAILED = 'search/GET_BOOK_LIST_FAILED'

export const RESET_SEARCH = 'search/RESET_SEARCH'

const initialState = {
  searchParallelStarted: false,
  searchParallelFailed: null,
  parallelSearchResults: null,
  searchMonoStarted: false,
  searchMonoFailed: null,
  monolingualSearchResults: null,
  getParallelTextStarted: false,
  getParallelTextFailed: null,
  getMonoTextStarted: false,
  getMonoTextFailed: null,
  parallelTextResults: null,
  monoTextResults: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_PARALLEL_START:
      return {
        ...state,
        searchParallelStarted: true,
        searchParallelFailed: null
      }

    case SEARCH_PARALLEL_SUCCEEDED:
      return {
        ...state,
        searchParallelStarted: false,
        searchParallelFailed: null,
        parallelSearchResults: {
          ...action.payload.results,
          collocations: compileCollection(action.payload.results)
        }
      }

    case SEARCH_PARALLEL_FAILED:
      return {
        ...state,
        searchParallelStarted: false,
        searchParallelFailed: action.error
      }

    case GET_PARALLEL_TEXT_START:
      return {
        ...state,
        getParallelTextStarted: true,
        getParallelTextFailed: null
      }

    case GET_PARALLEL_TEXT_SUCCEEDED:
      return {
        ...state,
        getParallelTextStarted: false,
        getParallelTextFailed: null,
        parallelTextResults: {
          ...action.payload.results
        }
      }

    case GET_PARALLEL_TEXT_FAILED:
      return {
        ...state,
        getParallelTextStarted: false,
        getParallelTextFailed: action.error
      }

    case SEARCH_MONO_START:
      return {
        ...state,
        searchMonoStarted: true,
        searchMonoFailed: null
      }

    case SEARCH_MONO_SUCCEEDED:
      return {
        ...state,
        searchMonoStarted: false,
        searchMonoFailed: null,
        monolingualSearchResults: {
          ...action.payload.results,
          collocations: compileCollection(action.payload.results)
        }
      }

    case SEARCH_MONO_FAILED:
      return {
        ...state,
        searchMonoStarted: false,
        searchMonoFailed: action.error
      }
    case GET_MONO_TEXT_START:
      return {
        ...state,
        getMonoTextStarted: true,
        getMonoTextFailed: null
      }

    case GET_MONO_TEXT_SUCCEEDED:
      return {
        ...state,
        getMonoTextStarted: false,
        getMonoTextFailed: null,
        monoTextResults: {
          ...action.payload.results
        }
      }

    case GET_MONO_TEXT_FAILED:
      return {
        ...state,
        getMonoTextStarted: false,
        getMonoTextFailed: action.error
      }

    case GET_BOOK_LIST_START:
      return {
        ...state,
        getBookListStarted: true,
        getBookListFailed: null
      }

    case GET_BOOK_LIST_SUCCEEDED:
      return {
        ...state,
        getBookListStarted: false,
        getBookListFailed: null,
        bookList: {
          ...action.payload.results
        }
      }

    case GET_BOOK_LIST_FAILED:
      return {
        ...state,
        getBookListStarted: false,
        getBookListFailed: action.error
      }
    case RESET_SEARCH:
      return {
        ...initialState,
        bookList: state.bookList
      }

    default:
      return state
  }
}

export const searchBilingual = ({ query, bookList, mode }) => {
  return dispatch => customFetch(
    api.SEARCH_PARALLEL_API,
    'POST',
    { query, bookList, mode },
    () => dispatch({
      type: SEARCH_PARALLEL_START
    }),
    json => dispatch({
      type: SEARCH_PARALLEL_SUCCEEDED,
      payload: {
        results: json
      }
    }),
    err => {
      !err.message && (err.message = 'Search failed. Please try again later.')
      dispatch({
        type: SEARCH_PARALLEL_FAILED,
        error: err.message
      })
    }
  )
}

export const searchMonolingual = ({ query, bookList, mode }) => {
  return dispatch => customFetch(
    api.SEARCH_MONO_API,
    'POST',
    { query, bookList, mode },
    () => dispatch({
      type: SEARCH_MONO_START
    }),
    json => dispatch({
      type: SEARCH_MONO_SUCCEEDED,
      payload: {
        results: json
      }
    }),
    err => {
      !err.message && (err.message = 'Search failed. Please try again later.')
      dispatch({
        type: SEARCH_MONO_FAILED,
        error: err.message
      })
    }
  )
}

export const getBookList = () => {
  return dispatch => customFetch(
    api.GET_BOOK_LIST_API,
    'POST',
    {},
    () => dispatch({
      type: GET_BOOK_LIST_START
    }),
    json => dispatch({
      type: GET_BOOK_LIST_SUCCEEDED,
      payload: {
        results: json.results
      }
    }),
    err => {
      !err.message && (err.message = 'Retrieving book list failed. Please try again later.')
      dispatch({
        type: GET_BOOK_LIST_FAILED,
        error: err.message
      })
    }
  )
}

export const getParallelText = ({ alignmentId, language, bookNames }) => {
  console.debug(`in getParallelText`)
  return dispatch => customFetch(
    api.GET_NEARBY_PARALLEL_TEXT_API,
    'POST',
    { alignment_id: alignmentId, language },
    () => dispatch({
      type: GET_PARALLEL_TEXT_START
    }),
    json => dispatch({
      type: GET_PARALLEL_TEXT_SUCCEEDED,
      payload: {
        results: {...json, language, alignmentId, bookNames}
      }
    }),
    err => {
      !err.message && (err.message = 'Parallel text retrieval failed. Please try again later.')
      dispatch({
        type: GET_PARALLEL_TEXT_FAILED,
        error: err.message
      })
    }
  )
}

export const getMonoText = ({ sentenceId, language }) => {
  console.debug(`in getMonoText`)
  return dispatch => customFetch(
    api.GET_NEARBY_MONO_TEXT_API,
    'POST',
    { sentenceId: sentenceId },
    () => dispatch({
      type: GET_MONO_TEXT_START
    }),
    json => dispatch({
      type: GET_MONO_TEXT_SUCCEEDED,
      payload: {
        results: {...json, language, sentenceId}
      }
    }),
    err => {
      !err.message && (err.message = 'Monolingual text retrieval failed. Please try again later.')
      dispatch({
        type: GET_MONO_TEXT_FAILED,
        error: err.message
      })
    }
  )
}


export const resetSearch = () => ({
  type: RESET_SEARCH
})